import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from 'react-redux'
import { getIsRedirected, getSubscriptionPlans } from '../../../../store/order/orderSelectors';
import { setSubscriptionPlanType, setSubscriptionPeriod, setIsRedirected } from '../../../../store/order/orderActions';
import "./Presale.scss";

const SmallTick = () => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54492 8.92439L8.55511 15.1084L21.1782 1.92236"
      stroke="#76BA1B"
      strokeWidth="3.63932"
      strokeLinecap="round"
    />
  </svg>
);

function Presale({ subscriptionPlans, onSetSubscriptionPlanType, onSetSubscriptionPeriod, onSetIsRedirected, isRedirected }) {
  const [currency, setCurrency] = useState("eur");
  const [period, setPeriod] = useState("yearly");
  const [isDevelopment, setIsDevelopment] = useState(true)

  useEffect(()=> {
    if(window.location.origin === 'https://qrcards-prod.herokuapp.com' || window.location.origin === 'https://www.qrcards.com') {
      setIsDevelopment(false)
    }
  },[])

  useEffect(()=> {
    if (isRedirected) {
      window.location.href = `/app/dashboard/subscription/order`
    }
  },[isRedirected])
  // ALWAYS DEVELOPMENT
  // useEffect(()=> {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     // development build code
  //     setIsDevelopment(true)
  //   } else {
  //     // production build code
  //     setIsDevelopment(false)
  // }
  // },[])

  useEffect(()=> {
    fetch('https://ipapi.co/json/')
    .then(function (response) {
        return response.json();
    })
    .then(function (payload) {
        let countryCode = payload.country_code
        if(countryCode === "GB") {
          setCurrency("gbp")
        }
        if(countryCode === "CZ") {
          setCurrency("czk")
        }
    });
  }, [])

  const handleRedirect = (type, period) => {
    onSetSubscriptionPlanType(type)
    onSetSubscriptionPeriod(period)
    onSetIsRedirected(true)
  }

  let subscriptionPlansList

  if (subscriptionPlans) {
    subscriptionPlansList = Object.values(subscriptionPlans).map((plan, i) => {
      const planByPeriod = plan[period][currency.toLowerCase()]
      
      return (
        <div className={`presale-card ${i > 1 ? 'extended' : ''}`}>
          {i > 1 && <div className="label"><FormattedMessage id={`home.presale.${i === 2 ? 'popular' : 'best'}`} /></div>}
          <p className="quantity">{planByPeriod.quantity} <FormattedMessage id="home.presale.codes" /></p>
          <p className={`price ${currency === "czk" ? "czk" : ""}`}>
            {planByPeriod.text}
          </p>
          <div className="period">
            {
              period === 'monthly' ?
                <FormattedMessage id="home.presale.monthly2" />
              :
                <FormattedMessage id="home.presale.yearly2" />
            }
          </div>
          <a class="presale-link" onClick={() => handleRedirect(planByPeriod.name, period)}>
            <button id="button 22" className="green-button"><FormattedMessage id="home.presale.select" /></button>
          </a>
          <p className="price-label"><FormattedMessage id="home.presale.allFeatures" /></p>
          {/* <div className="upcoming-price">
            {prices.upcoming[currency][0]}{" "}
            / <FormattedMessage id="home.presale.month" /><div className="red-bar"></div>{" "}
          </div> */}
        </div>
      )
    })
  }
  
  return (
    <section id="benefits-for-first-users">
      <h2 id="pricing"><FormattedMessage id="home.presale.h" /></h2>
      <p>
        <FormattedMessage id="home.presale.p" />
      </p>
      <div className="buttons-wrapper">
        <button onClick={()=> setPeriod("monthly")} className={`switch-button ${period === "monthly" ? "selected" : ""}`}>
          <FormattedMessage id="dashboard.subscription.monthly" />
        </button>
        <button onClick={()=> setPeriod("yearly")} className={`switch-button ${period === "yearly" ? "selected" : ""}`}>
          <FormattedMessage id="dashboard.subscription.yearly" />
          <p>
            <FormattedMessage id="dashboard.subscription.save" /> 40%
          </p>
        </button>
      </div>
      <div className="cards-scroller">
        <div className="cards-section">
         {subscriptionPlansList}
        </div>
      </div>
      <div className="secure">
        <svg
          width="18"
          height="25"
          viewBox="0 0 18 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.4634 9.59696H14.879V6.32388C14.6452 3.22615 12.0735 0.712891 8.85883 0.712891C5.70264 0.712891 3.07249 3.22615 2.89715 6.32388V9.59696H2.31267C1.02682 9.59696 0.0332031 10.7075 0.0332031 12.0518V22.3386C0.0332031 23.6829 1.08526 24.7934 2.31267 24.7934H8.74193H15.405C16.6908 24.7934 17.6845 23.6829 17.6845 22.3386V12.0518C17.7429 10.7075 16.6908 9.59696 15.4634 9.59696ZM4.53369 6.84991C4.65058 4.57045 6.57936 2.75856 8.85883 2.75856C11.1383 2.75856 13.0671 4.57045 13.184 6.84991V9.59696H8.74193H4.53369V6.84991Z"
            fill="#FFFFFF"
          />
        </svg>
        <p><FormattedMessage id="home.presale.secure" /> <b><FormattedMessage id="home.presale.secureWithoutVAT" /></b></p>
      </div>
      <div className="select-currency">
        <span><FormattedMessage id="home.presale.selectCurrency" /></span>
        <span
          onClick={() => setCurrency("eur")}
          className={`currency ${currency === "eur" ? "selected" : ""}`}
        >
          EUR
        </span>
        <span
          onClick={() => setCurrency("usd")}
          className={`currency ${currency === "usd" ? "selected" : ""}`}
        >
          USD
        </span>
        <span
          onClick={() => setCurrency("czk")}
          className={`currency ${currency === "czk" ? "selected" : ""}`}
        >
          CZK
        </span>
        <span
          onClick={() => setCurrency("gbp")}
          className={`currency ${currency === "gbp" ? "selected" : ""}`}
        >
          GBP
        </span>
      </div>
      {/* <div className="price-guarantee">
      <FormattedMessage id="home.presale.priceGuarantee" />
      </div> */}
      <div className="content">
        <div className="column">
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point1" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point2" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point3" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point4" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point5" /></p>
          </div>
        </div>
        <div className="column">
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point6" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point7" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point8" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point9" /></p>
          </div>
          <div className="wrapper">
            <SmallTick />
            <p><FormattedMessage id="home.presale.point10" /></p>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapState = (state) => ({
  subscriptionPlans: getSubscriptionPlans(state),
  isRedirected: getIsRedirected(state),
})

const mapDispatch = (dispatch) => ({
  onSetSubscriptionPlanType: (type) => dispatch(setSubscriptionPlanType(type)),
  onSetSubscriptionPeriod: (period) => dispatch(setSubscriptionPeriod(period)),
  onSetIsRedirected: (isRedirected) => dispatch(setIsRedirected(isRedirected)),
})

export default connect(mapState, mapDispatch)(Presale)
